
import React, { useState } from "react";
const AppContext = React.createContext();
export const AppProvider = ({ children }) => {
 
  const [baseUrl] = useState("https://journeyjunction.btsportfolio2026.com/backend/public/api");
  // const [baseUrl] = useState("http://127.0.0.1:8000/api");
  const [imageBaseUrl] =useState("https://journeyjunction.btsportfolio2026.com/backend/public/storage");
  // const [imageBaseUrl] = useState("http://127.0.0.1:8000/storage");
  const [activeSidebar, setActiveSidebar] = useState("dashboard");
  const [isCollapsed, setIsCollapsed] = useState(false); 
  const [authToken, setAuthToken] = useState(() =>
    localStorage.getItem("authToken"),
  );
  const[get,set]=useState();
  const [getadmin, setadmin] = useState();
  const [selectedBookingId, setSelectedBookingId] = useState(null);
  const [selectedPaymentId, setSelectedPaymentId] = useState(null);
  const [selectedPackageId, setSelectedPackageId] = useState(null);
  const [vendorId, setVendorId] = useState(() =>
    localStorage.getItem("vendorId"),
  );
  const [hotelId, setHotelId] = useState(() => localStorage.getItem("hotelId"));

  const [showBlogForm, setShowBlogForm] = useState(false);
  const [selectedBlog, setSelectedBlog] = useState(null);
  const [blogs, setBlogs]               = useState([]);
  const [selectedDestination, setSelectedDestination] = useState(null);
  const [destinations, setDestinations] = useState([]);
  const [destinationToast, setDestinationToast] = useState({ show: false, message: "", type: "info" });
  const [loading, setLoading] = useState(false);
const [review, setreview] = useState(false);
const[notifications,setnotification] =useState([]);
  const storeActiveSidebar = (asb) => setActiveSidebar(asb);
  const toggleCollapsed = () => setIsCollapsed((prev) => !prev);

  const validateField = (type, value) => {
    const v = (value || "").toString().trim();

    switch (type) {
      case "email":
        if (!v) return "Email address is required";
        if (!/^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[A-Za-z]{2,}$/.test(v))
          return "Please enter a valid email address";
        return "";
      case "phone":
        if (!v) return "Phone number is required";
        if (!/^[0-9]{11}$/.test(v.replace(/[-\s]/g, "")))
          return "Please enter a valid 11-digit phone number";
        return "";
      case "username":
        if (!v) return "Username is required";
        if (v.length < 3) return "Username must be at least 3 characters";
        if (v.length > 20) return "Username must be less than 20 characters";
        if (!/^[a-zA-Z0-9_]+$/.test(v))
          return "Username can only contain letters, numbers, and underscores";
        return "";
      case "name":
        if (!v) return "Full name is required";
        if (v.length < 3) return "Name must be at least 3 characters";
        return "";
      case "required":
        if (!v) return "This field is required";
        return "";
    case "password":
        if (!v) return "Password is required";
        if (v.length < 8) return "Password must be at least 8 characters";
        if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/.test(v))
          return "Password must contain uppercase, lowercase, and number";
        return ""; 
      default:
        return "";
    }
  };

  const validateForm = (rules) => {
    const errors = {};
    rules.forEach(({ field, type, value }) => {
      const err = validateField(type, value);
      if (err) errors[field] = err;
    });
    return { isValid: Object.keys(errors).length === 0, errors };
  };

  const isUserLoggedIn = () => {
    const role = localStorage.getItem("userRole");
    if (role === "vendor")
      return !!(localStorage.getItem("vendorEmail") && localStorage.getItem("vendorId"));
    if (role === "customer")
      return !!(localStorage.getItem("customerEmail") && localStorage.getItem("customerId"));
    if (role === "admin") return !!localStorage.getItem("adminEmail");
    return false;
  };

  const getUserRole = () => localStorage.getItem("userRole");

  const getCurrentUser = () => {
    const role = localStorage.getItem("userRole");
    if (role === "vendor")
      return {
        role,
        email: localStorage.getItem("vendorEmail"),
        id: localStorage.getItem("vendorId"),
        name: localStorage.getItem("userName"),
      };
    if (role === "customer")
      return {
        role,
        email: localStorage.getItem("customerEmail"),
        id: localStorage.getItem("customerId"),
        name: localStorage.getItem("userName"),
      };
    if (role === "admin")
      return {
        role,
        email: localStorage.getItem("adminEmail"),
        id: localStorage.getItem("authToken"),
      };
    return null;
  };

  const vendorloggedin = () =>
    [
      "vendorEmail",
      "vendorPassword",
      "userRole",
      "vendorId",
      "userName",
      "hotelId",
    ].forEach((k) => localStorage.removeItem(k));
    
  const customerloggedin = () =>
    [
      "customerEmail",
      "customerPassword",
      "userRole",
      "customerId",
      "userName",
    ].forEach((k) => localStorage.removeItem(k));
    

  const adminloggedin = () =>
    ["adminEmail", "adminPassword", "adminRole", "authToken"].forEach((k) => localStorage.removeItem(k));

  const showDestinationToast = (message, type = "info") => {
    setDestinationToast({ show: true, message, type });
    setTimeout(() => {
      setDestinationToast({ show: false, message: "", type: "info" });
    }, 3000);
  };

  const hideDestinationToast = () => {
    setDestinationToast({ show: false, message: "", type: "info" });
  };

  const openEditBlog = (blog) => {
    setSelectedBlog(blog);
    setShowBlogForm(true);
  };

  const openCreateBlog = () => {
    setSelectedBlog(null);
    setShowBlogForm(true);
  };

  const closeBlogForm = () => {
    setSelectedBlog(null);
    setShowBlogForm(false);
  };

  return (
    <AppContext.Provider
      value={{
        baseUrl,
        activeSidebar,
        storeActiveSidebar,
        isCollapsed,
        toggleCollapsed,
        setIsCollapsed,
        authToken,
        setAuthToken,
        vendorId,
        setVendorId,
        hotelId,
        setHotelId,
        validateField,
        validateForm,
        isUserLoggedIn,
        getUserRole,
        getCurrentUser,
        vendorloggedin,
        customerloggedin,
        adminloggedin,
        selectedBookingId,
        setSelectedBookingId,
        selectedPaymentId,
        setSelectedPaymentId,
        getadmin,
        setadmin,
        selectedPackageId,
        setSelectedPackageId,
        blogs,
        setBlogs,
        showBlogForm,
        setShowBlogForm,
        selectedBlog,
        setSelectedBlog,

        openEditBlog,       
        openCreateBlog,    
        closeBlogForm,      

        selectedDestination,
        setSelectedDestination,
        destinations,
        setDestinations,
        destinationToast,
        showDestinationToast,
        hideDestinationToast,
        loading,
        setLoading,
       review, setreview,
        notifications,setnotification,
         imageBaseUrl,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export default AppContext;